<script>
    import { fade } from 'svelte/transition'
    export let pronouns;
    export let validity = {
        is_valid: false,
        message: "I want to be called"
    }

    const bannedTerms = [
        'helicopter',
        'hitler',
        'apache',
    ]
    const invalidate = () => {
        validity.is_valid = false
    }
    const checkPronouns = async () => {
        validity.is_valid = false
        await new Promise(r => setTimeout(r, 1000));

        const re = /[a-z]+/g;
        let input = (pronouns.toLowerCase().match(re) || []).join("")
        if (bannedTerms.find(term => input.includes(term))) {
            return false;
        }
        validity.is_valid = true
        /* validity.message = "What if I call myself" */
        return false;
    }
</script>

<main transition:fade>
    <h1>Are my pronouns valid?</h1>
    <div id="validity">
        {#if validity.is_valid}
            <h2 transition:fade>Valid.</h2>
        {/if}
    </div>
    <form on:submit|preventDefault={checkPronouns}>
        <label transition:fade for="mypronouns">{validity.message}</label>
        <input id="mypronouns" on:input={invalidate} bind:value={pronouns}>
        <button id="check" type="submit" on:click={checkPronouns}>Check</button>
    </form>
</main>

<style>
    main {
        text-align: center;
        padding: 1em;
        margin: 0 auto 15em auto;
    }

    h1 {
        /*color: #ff3e00;*/
        color: #333;
        font-size: 4em;
        font-weight: normal;
    }

    h2 {
        font-size: 3em;
    }

    #validity {
        min-height: 5em;
        color: green;
    }

    @media (min-width: 640px) {
        label {
            display: inline-block;
            min-width: 0;
        }
        main {
            max-width: none;
        }
    }
    @media (max-width: 1080px) {
        h1 {
            margin-top: 0.1em;
        }
        label {
            margin-bottom: 1em;
        }
    }
</style>
